import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/home/Section3.css'; // Updated import path

const Section3 = () => {
  <link rel="stylesheet" href="styles.css?v=2"></link>
  return (
    <section className="hero-section">
      <div className="content-container">
        <h1 className="main-heading">We Handle Everything</h1>
        <p className="subtext">Recruiting, training, managing, scaling: we own the whole pipeline so you don’t 
          have to. Within a matter of weeks, your brand can have nationwide representation across campuses. 
        </p>
        
        <div className="cta-container">
          <Link to="/brands"><button className="learn-more-btn">Learn More</button></Link>
        </div>
      </div>

      {/* Image placeholder container */}
      <div className="image-container">
        <div className="image-placeholder3"></div>
      </div>
    </section>
  );
};

export default Section3;